var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.glyph))])
}
var staticRenderFns = []

export { render, staticRenderFns }